import { config } from "../config";
import { shortAddr } from "../lib/format";
import { Card, Notice, Stat } from "../components/ui";

export function Bridge() {
  const l1 = config.l1.contracts;
  return (
    <>
      <div className="section-title">Bridge a Brain</div>
      <Card title="L1 ⇄ L2 Brain bridging" sub="Brains are minted on Ethereum, then bridged to Ink to operate.">
        <p className="muted" style={{ fontSize: 14.5 }}>
          A Brain NFT is minted on Ethereum by staking Pepecoin or $basedAI. To operate the Brain, stake, or vote on
          Ink, bridge it via Ink&apos;s <strong>canonical ERC-721 bridge</strong>. The optional{" "}
          <span className="mono">BrainBridgeAdapter</span> gives a one-call deposit; withdrawal uses the standard
          Ink flow (burns the L2 Brain, releases the L1 escrow).
        </p>
        <div className="grid cols-2" style={{ marginTop: 8 }}>
          <Stat label="L1 Brain NFT" value={<span className="mono" style={{ fontSize: 13 }}>{shortAddr(l1.brainNFT)}</span>} />
          <Stat label="Bridge adapter" value={<span className="mono" style={{ fontSize: 13 }}>{shortAddr(l1.bridgeAdapter)}</span>} />
          <Stat label="Canonical L1 ERC-721 bridge" value={<span className="mono" style={{ fontSize: 13 }}>{shortAddr(l1.l1Erc721Bridge)}</span>} />
          <Stat label="L2 Brain NFT" value={<span className="mono" style={{ fontSize: 13 }}>{shortAddr(config.l2.contracts.brainNFTL2)}</span>} />
        </div>
        <div style={{ marginTop: 18 }} className="row">
          <a className="btn" href={config.bridgeUrl} target="_blank" rel="noreferrer">
            Open Ink bridge →
          </a>
          <a className="btn ghost" href={`${config.l1.explorer}/address/${l1.brainNFT}`} target="_blank" rel="noreferrer">
            View L1 Brain NFT
          </a>
        </div>
        <div style={{ marginTop: 16 }}>
          <Notice kind="warn">
            Minting and bridging happen on <strong>{config.l1.name}</strong> (L1). Your wallet will prompt you to
            switch networks. Stake-minted Brains are soulbound except into/out of the authorized bridge.
          </Notice>
        </div>
      </Card>
    </>
  );
}
